module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "mt-checkbox mt-checkbox-outline",
    attrs: {
      "id": _vm.field.name
    }
  }, [_vm._v("\n  " + _vm._s(_vm.field.label) + "\n  "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.required && !_vm.field.hide
      }),
      expression: "{required: required && !field.hide}"
    }],
    attrs: {
      "data-vv-as": _vm.field.description.replace(/\./g, ''),
      "name": _vm.field.name,
      "type": "checkbox",
      "disabled": _vm.locked,
      "readonly": _vm.locked
    },
    domProps: {
      "value": _vm.field.label,
      "checked": !!_vm.value
    },
    on: {
      "change": function($event) {
        return _vm.$emit('input', $event.target.checked ? _vm.field.label : '')
      }
    }
  }), _vm._v(" "), _c('span')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23f91adb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/render/CheckboxRender.vue
// module id = 1583
// module chunks = 1